import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { unAutPage, userGuard } from "@/store/utils/userGourad";

import { Mutations } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },

      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/admin/users/pages/ProfilePage.vue"),
      },

      // !! Admin Users Pages
      {
        path: "/admin/user",
        component: () => import("@/views/admin/users/UserViewPanel.vue"),
        children: [
          {
            meta: {
              permissions: "ManageUsers",
            },
            path: "/admin/users",
            name: "admin-users",
            component: () => import("@/views/admin/users/list-pages/UsersListPage.vue"),
          },
          {
            meta: {
              permissions: "ManageUsers",
            },
            path: "/admin/users-detail/:id",
            name: "admin-users-detail",
            component: () => import("@/views/admin/users/pages/UserDetail.vue"),
          },
          {
            meta: {
              permissions: "ManageUserGroups",
            },
            path: "/admin/user-roles",
            name: "admin-user-roles",
            component: () => import("@/views/admin/users/list-pages/UserRoleListPage.vue"),
          },
        ],
      },
      // !! Admin Customers Pages
      {
        path: "/admin/customer",
        component: () => import("@/views/admin/customers/CustomerViewPanel.vue"),
        children: [
          {
            path: "/customers/detail/:id",
            name: "detail-customers",
            meta: {
              permissions: "ManageCustomers",
            },
            component: () => import("@/views/admin/customers/pages/CustomerDetails.vue"),
          },
          {
            path: "/customers/project-detail/:id",
            name: "detail-project",
            meta: {
              permissions: "ManageProjects",
            },
            component: () => import("@/views/admin/customers/pages/ProjectDetails.vue"),
          },
          {
            path: "/admin/customers",
            name: "admin-customers",
            meta: {
              permissions: "ManageCustomers",
            },
            component: () => import("@/views/admin/customers/list-pages/CustormersListPage.vue"),
          },
          {
            path: "/admin/locations",
            name: "admin-locations",
            meta: {
              permissions: "ManageLocations",
            },
            component: () => import("@/views/admin/customers/list-pages/LocationListPage.vue"),
          },
          {
            path: "/admin/projects",
            name: "admin-projects",
            meta: {
              permissions: "ManageProjects",
            },
            component: () => import("@/views/admin/customers/list-pages/ProjectListPage.vue"),
          },
          {
            path: "/admin/operations",
            name: "admin-operations",
            meta: {
              permissions: "ManageOperationTypes",
            },
            component: () => import("@/views/admin/customers/list-pages/OperationListTypePage.vue"),
          },
        ],
      },
      // !! Admin Company Page
      {
        path: "/company",
        name: "company",
        meta: {
          permissions: "ManageMyCompany",
        },
        component: () => import("@/views/admin/company/Company.vue"),
      },
      {
        path: "/companyList",
        name: "companyList",
        meta: {
          permissions: "ManageCompanies",
        },
        component: () => import("@/views/admin/company/list-pages/CompanyList.vue"),
      },
      {
        path: "/companies/detail/:id",
        name: "detail-company",
        meta: {
          permissions: "ManageCompanies",
        },
        component: () => import("@/views/admin/company/CompanyAdmin.vue"),
      },
      // !! System Admin Template Pages

      {
        path: "/admin/template",
        component: () => import("@/views/admin/templates/TemplateComponentView.vue"),
        children: [
          {
            path: "/admin/template/list",
            name: "admin-template-list",
            meta: {
              permissions: "ManageCompanies",
            },
            component: () => import("@/views/admin/templates/template-list-pages/AdminTemplates.vue"),
          },
          {
            path: "/admin/template/edit-template/:id",
            name: "admin-template-edit-template",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item/EditChecklistPage.vue"),
          },
          {
            path: "/admin/template/new-template",
            name: "admin-template-new-template",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item/ChecklistCreatePage.vue"),
          },
          {
            path: "/admin/template/answertemplates/list",
            name: "admin-template-answertemplates-list",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item-list/Answers.vue"),
          },
          {
            path: "/admin/template/categories/list",
            name: "admin-template-categories-list",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item-list/Categorys.vue"),
          },
          {
            path: "/admin/template/sections/list",
            name: "admin-template-sections-list",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item-list/Department.vue"),
          },
          {
            path: "/admin/template/questions/list",
            name: "admin-template-questions-list",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item-list/Questions.vue"),
          },
          {
            path: "/admin/template/questions/new-questions",
            name: "admin-template-new-questions",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item/NewQuestionPage.vue"),
          },
          {
            path: "/admin/template/questions/edit-questions/:id",
            name: "admin-template-edit-questions",
            meta: {
              permissions: "ManageChecklistTemplates",
            },
            component: () => import("@/views/admin/templates/template-item/EditQuestionPage.vue"),
          },
        ],
      },

      // !! Audit Pages
      {
        path: "/audit",
        component: () => import("@/views/audit/Audit.vue"),
        children: [
          {
            path: "/analysis",
            name: "analysis",
            meta: {
              permissions: "ManageAuditAnalysis",
            },
            component: () => import("@/views/audit/pages/Analysis.vue"),
          },
          {
            path: "/auditlist",
            name: "audit-list",
            meta: {
              permissions: "ManageAuditPlans",
            },
            component: () => import("@/views/audit/list-pages/AuditPlanningList.vue"),
          },
          {
            path: "/audit/audit-details/:id",
            name: "audit-details",
            props: true,
            meta: {
              permissions: "ManageReports",
            },
            component: () => import("@/views/audit/pages/AuditDetails.vue"),
          },

          {
            path: "/auditactions",
            name: "audit-actions",
            meta: {
              permissions: "ManageAuditActions",
            },
            component: () => import("@/views/audit/list-pages/ActionListPage.vue"),
          },
          {
            path: "/auditactions/actiondetail/:id",
            name: "action-detail",
            meta: {
              permissions: "ManageAuditActions",
            },
            component: () => import("@/views/audit/pages/ActionDetail.vue"),
          },
        ],
      },
      // ! Checklist Items Pages
      {
        path: "/checklistitems",
        component: () => import("@/views/checkListItem/CheckListItems.vue"),
        children: [
          {
            path: "/templates",
            name: "templates",
            meta: {
              permissions: "ManageChecklists",
            },
            component: () => import("@/views/checkListItem/list-pages/UserTemplates.vue"),
          },
          {
            path: "/categorys",
            name: "categorys",
            meta: {
              permissions: "ManageCategories",
            },
            component: () => import("@/views/checkListItem/list-pages/Categorys.vue"),
          },
          {
            path: "/sections",
            name: "sections",
            meta: {
              permissions: "ManageDepartments",
            },
            component: () => import("@/views/checkListItem/list-pages/Department.vue"),
          },
          {
            path: "/answer-templates",
            name: "answer-templates",
            meta: {
              permissions: "ManageAnswerTemplates",
            },
            component: () => import("@/views/checkListItem/list-pages/Answers.vue"),
          },
          {
            path: "/questions",
            name: "questions",
            meta: {
              permissions: "ManageQuestions",
            },
            component: () => import("@/views/checkListItem/list-pages/Questions.vue"),
          },
          {
            path: "/questions/new-questions",
            name: "new-questions",
            meta: {
              permissions: "ManageQuestions",
            },
            component: () => import("@/views/checkListItem/pages/NewQuestionPage.vue"),
          },
          {
            path: "/questions/edit-questions/:id",
            name: "edit-questions",
            meta: {
              permissions: "ManageQuestions",
            },
            component: () => import("@/views/checkListItem/pages/EditQuestionPage.vue"),
          },

          {
            path: "/checklists",
            name: "checklists",
            meta: {
              permissions: "ManageChecklists",
            },
            component: () => import("@/views/checkListItem/list-pages/CheckList.vue"),
          },

          {
            path: "/checklists/edit-checklist/:id",
            name: "edit-checkList",
            meta: {
              permissions: "ManageChecklists",
            },
            component: () => import("@/views/checkListItem/pages/EditChecklistPage.vue"),
          },
          {
            path: "/checklists/new-checklist",
            name: "new-checklist",
            meta: {
              permissions: "ManageChecklists",
            },
            component: () => import("@/views/checkListItem/pages/ChecklistCreatePage.vue"),
          },
        ],
      },
    ],
  },

  // !! Not Authorized Pages
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },

      {
        path: "/password-reset",
        name: "password-reset",
        component: () => import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: () => import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
  },
  {
    path: "/install-data-base",
    name: "install-data-base",
    component: () => import("@/views/InstallDB.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (unAutPage(to.name)) {
    next();
  } else {
    if (!store.getters["AuthModule/_isAuthorization"]) {
      router.push({ name: "sign-in" });
    }

    if (to.meta.permissions !== undefined) {
      if (!userGuard(to.meta.permissions)) {
        router.push({ name: "dashboard" });
      }
    }
    next();
  }

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
//
export default router;
